import React from 'react';
import { Loading } from 'react-admin';

import Edit from '../common/views/Edit';
import ReviewForm from './ReviewForm';
import useReviewGrid from './useReviewGrid';

// Only the editable fields are sent: the server ignores the rest, but a smaller payload keeps
// computed data (actions, history, people) out of the request.
const EDITABLE_FIELDS = [
    'period_label', 'period_start', 'period_end', 'stage_current', 'stage_target',
    'scores', 'values_note', 'strengths', 'improvements', 'objectives'
];

const transform = (data) => Object.fromEntries(EDITABLE_FIELDS.map(field => [field, data[field]]));

const ReviewEdit = (props) => {
    const grid = useReviewGrid();

    if (!grid) {
        return <Loading />;
    }

    return (
        <Edit {...props} transform={transform} redirect="show">
            <ReviewForm grid={grid} />
        </Edit>
    );
};

export default ReviewEdit;
